<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        height="800px"
        width="800px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 496.158 496.158"
        xml:space="preserve"
    >
        <path
            style="fill: #ffe5e0"
            d="M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07  c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
        />
        <path
            style="fill: #fe6244"
            d="M248.079,73.593c0,0-70.669,94.074-70.669,133.103s31.64,70.669,70.669,70.669  c39.028,0,70.669-31.64,70.669-70.669S248.079,73.593,248.079,73.593z"
        />
        <g>
            <path
                style="fill: #ffe5e0"
                d="M254.079,264.074c29.916,0,54.169-24.252,54.169-54.168S224.162,264.074,254.079,264.074z"
            />
            <path
                style="fill: #fe6244"
                d="M372.891,242.327c10.17,8.656,15.936,18.512,15.936,28.968c0,34.442-62.429,62.364-139.438,62.364   c-77.006,0-139.436-27.922-139.436-62.364c0-10.456,5.764-20.312,15.936-28.968c-19.319,11.524-22.474,27.417-22.474,42.095   c0,36.056,65.355,65.287,145.974,65.287c80.621,0,145.975-29.231,145.975-65.287C395.363,269.744,392.209,253.851,372.891,242.327z   "
            />
            <path
                style="fill: #fe6244"
                d="M408.397,245.302c13.097,11.146,20.519,23.834,20.519,37.295c0,44.346-80.378,80.295-179.527,80.295   c-99.146,0-179.525-35.949-179.525-80.295c0-13.461,7.422-26.149,20.516-37.295c-24.871,14.838-28.933,35.299-28.933,54.197   c0,46.422,84.146,84.057,187.942,84.057c103.799,0,187.943-37.635,187.943-84.057C437.332,280.6,433.271,260.14,408.397,245.302z"
            />
            <path
                style="fill: #fe6244"
                d="M338.492,239.955c7.34,6.245,11.498,13.356,11.498,20.9c0,24.849-45.042,44.993-100.602,44.993   c-55.559,0-100.6-20.145-100.6-44.993c0-7.544,4.158-14.655,11.496-20.9c-13.938,8.314-16.213,19.781-16.213,30.37   c0,26.014,47.152,47.104,105.316,47.104c58.166,0,105.318-21.09,105.318-47.104C354.707,259.736,352.432,248.269,338.492,239.955z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "EmptyIcon",
};
</script>
